<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title"><span v-show="wishlists.length > 0">{{wishlists.length }}</span> Favori<span v-show="wishlists.length > 0">s</span>
      </span>
    </sticky>
    <div class="is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
      <spinner-round :isLoading="loading"></spinner-round>
      <table v-show="!loading" class="table is-fullwidth is-last-fixed-small is-first-fixed-large"
        v-if="wishlists.length">
        <thead>
        <tr class="is-size-6">
          <th>
            Date D'ajout
          </th>
          <th>
            Numéro Lot
          </th>
          <th>
            Programme
          </th>
          <th class="has-text-centered">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="wishlist in wishlists" :key="wishlist.pk" @click.prevent.stop="goToLotView(wishlist, $event)" class="is-size-6">
          <td>
            {{wishlist.created_on | prettyDate}}
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'LotVue', params: {id: wishlist.lot }}">{{wishlist.lot_ref}}</router-link>
          </td>
          <td>
            {{wishlist.program_name | truncate}}
          </td>
          <td class="has-text-centered actions">
            <!-- <display-button-list :forceDropDown="true" @hover="buttonListHover(wishlist)" :buttons="buttonList"
                                 :data="wishlist">
            </display-button-list> -->
            <button class="button is-circle is-small tooltip is-tooltip-left" @click.prevent.stop="deleteFromWishlist(wishlist.pk)" data-tooltip="Supprimer des favoris">
                <i class="fal fa-trash"></i>
              </button>
          </td>
        </tr>
        <!--<tr class="empty empty--row" v-for="n in wishlists.length < 8 ? 8 - wishlists.length : 0 " :key="n"><td class="is-borderless"></td></tr>-->
        </tbody>
      </table>
      <div v-else v-show="!loading">
        <div class="columns">
          <div class="column">
            <h2 class="title is-3 has-text-weight-bold">Aucun lot disponible dans votre liste de favoris</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GenericList, Sort } from '../../mixins'
  import { mapState } from 'vuex'

  export default {
    name: 'LotWishlistList',
    mixins: [GenericList, Sort],
    filters: {
      prettyTaxDispositifs (values, data) {
        return values.map((x, i) => {
          if (i < 2) {
            return data[x].short_label || data[x].label
          }
        }).join(', ')
      },
      dotClass (value) {
        const COLORS = {
          'available': 'is-disponible',
          'optioned': 'is-optionne',
          'sold': 'is-acte',
          'draft': 'is-draft',
          'reserved': 'is-reserve'
        }
        return COLORS[value]
      }
    },
    data () {
      return {
        actionButtons: [
          {
            linkClass: ['button', 'is-white'],
            icon: ['fa-sync']
          }
        ],
        buttonList: [
          {
            icon: 'fa-flag',
            text: 'Supprimer des favoris',
            action: (wishlist) => {
              this.deleteFromWishlist(wishlist)
            }
          }
        ],
        selectedLot: null,
        loading: false,
        loadDocuments: this.loadItems,
        service: this.$api.lotService
      }
    },
    computed: {
      ...mapState(['wishlists'])
    },
    methods: {
      buttonListHover (lot) {
        return lot
      },
      goToLotView (wishlist) {
        this.$router.push({name: 'LotVue', params: {id: wishlist.lot}})
      },
      deleteFromWishlist (id) {
        this.$api.lotService.deleteWishlist(id).then(() => {
          this.$store.commit('removeWishlist', {wishlistPk: id})
          this.$notify({
            type: 'is-success',
            text: 'Supprimé de la liste des favoris'
          })
        })
      }
    },
    created () {
      this.$api.lotService.getWishlist().then(r => {
        this.$store.commit('setWishlist', {wishlists: r.data.reverse()})
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/LotWishlistList.vue